import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const getData = (sensores) => {

    const CO = sensores.map(item => item.CO);
    const CO2 = sensores.map(item => item.CO2);
    const metanos = sensores.map(item => item.metanos);
    const humo = sensores.map(item => item.humo);
    const vapores = sensores.map(item => item.vapores);
    const O3 = sensores.map(item => item.O3);
    const hora = sensores.map(item => item.fecha);

    return {
        labels: hora,
        datasets: [
            {
                label: 'Propano / GLP',
                data: CO,
                borderColor: 'rgb(220, 20, 60)',
                backgroundColor: 'rgba(220, 20, 60, 0.5)',
            },
            {
                label: 'Alcohol / Etanol',
                data: CO2,
                borderColor: 'rgb(65, 105, 225)',
                backgroundColor: 'rgba(65, 105, 225, 0.5)',
            },
            {
                label: 'Metano (CH₄)',
                data: metanos,
                borderColor: 'rgb(255, 255, 0)',
                backgroundColor: 'rgba(255, 255, 0, 0.5)',
            },
            {
                label: 'Butano / GLP',
                data: humo,
                borderColor: 'rgb(255, 125, 125)',
                backgroundColor: 'rgba(255, 125, 125, 0.5)',
            },
            {
                label: 'Monóxido de C',
                data: vapores,
                borderColor: 'rgb(0, 255, 0)',
                backgroundColor: 'rgba(0, 255, 0, 0.5)',
            },
            {
                label: 'CO (alta conc.)',
                data: O3,
                borderColor: 'rgb(0, 0, 60)',
                backgroundColor: 'rgba(0, 0, 60, 0.5)',
            }
        ],
    };
};

const getOptions = () => ({
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Relation gas node',
        },
    },
});

const ChartGases = ({ data, chartId }) => {
    const chartRef = useRef(null);

    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            data={getData(data)}
            options={getOptions()}
        />
    );
};

export default ChartGases;
